import { ChartPro } from "../chart-pro";

export function ChartView() {
    return  <ChartPro />   
}